import { handleResponse, handleError, MyAxios, priorityHandleError } from '@services/SettingAxios';
import { TypePromiseReviewsByShop, TypePromiseReviewsRegion } from './TypePromise';
import { PropsReviewByShop } from './Api.dto';

class ServiceReviewsShop {
  async getReviewsRegion(regionId: number): Promise<TypePromiseReviewsRegion> {
    return MyAxios.get(`/api/comment/by-region?region=${regionId}`)
      .then(handleResponse)
      .catch(error => handleError(error, { comentsList: [], url: '/pages/view/obratnaya-svyaz/' }));
  }

  async getReviewsByShop(shopId: number, page: number = 1): Promise<TypePromiseReviewsByShop> {
    return MyAxios.get(`/api/comment/by-shop?shopid=${shopId}&page=${page}`)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  }

  async pushReviewByShop(query: PropsReviewByShop) {
    return MyAxios.post('/api/comment/create', {
      ...query,
      text: query.message,
      shopid: query.id,
    })
      .then(handleResponse)
      .catch(priorityHandleError);
  }
}

const serviceReviewsShopInstance = new ServiceReviewsShop();

export default serviceReviewsShopInstance;
